import { ROUTES_LIVE_ALL_SESSIONS, ROUTES_LIVE_SINGLE_SESSION } from '@/constants/routes';
import store from '@/store';
import { guardRoute } from '@/router';

export default {
    path: '/live',
    name: 'live',
    component: () => import(/*webpackChunkName: 'live'*/ '@/views/Live.vue'),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    children: [
        {
            path: '/live/all-sessions/sessions',
            name: ROUTES_LIVE_ALL_SESSIONS,
            beforeEnter: guardRouteLive,
            component: () =>
                import(/*webpackChunkName: 'live-all-sessions'*/ '@/components/live/all-sessions/LiveAllSessions.vue')
        },
        {
            path: '/live/session/:id?',
            name: ROUTES_LIVE_SINGLE_SESSION,
            beforeEnter: guardRouteLive,
            component: () =>
                import(
                    /*webpackChunkName: 'live-single-session'*/ '@/components/live/single-session/LiveSingleSession.vue'
                )
        }
    ]
};

function guardRouteLive(to, from, next) {
    const unauthorized = !store.getters.isCurrentUserCoachOfSelectedClub;
    guardRoute(next, unauthorized);
}
